export default {
  init(vue) {
    return {
      queryOrders(searchParams) {
        return vue.$http({
          method: 'GET',
          url: `/pages/card/query`,
          params: searchParams
        })
      },
      queryOrderArea() {
        return vue.$http({
          method: 'GET',
          url: `/shop/jiyun/card/queryOrderArea`
        })
      },
      queryNumberPool() {
        return vue.$http({
          method: 'GET',
          url: `/shop/jiyun/card/queryNumberPool`
        })
      },
      /**
       * 
       * @param {*} form 
          cardNo:653125189656565656
          cardName:证件名
          mobile:15730146051
          provinceCode:551
          cityCode:556
          realCheckReqNo:230520200208212226000652
          //transactionId:1111111
          packageId:1497
          receiverName:亢林妮
          receiverPhone:13032975280
          receiverProvinceName:陕西
          receiverCityName:西安市
          receiverTownName:雁塔区
          receiverStreetName:城区
          receiverProvinceCode:27
          receiverCityCode:308
          receiverTownCode:2946
          //receiverStreetCode:38034
          receiverAdd:测试地址
          channel:TTCHANNEL
       */
      createCardOrderOAO(form) {
        return vue.$http({
          method: 'POST',
          url: `/shop/jiyun/card/createCardOrderOAO`,
          data: form
        })
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/service/jiyun.service.js